import React, { useEffect, useState } from 'react';
import {
  Box,
  ButtonToggle,
  ButtonToggleGroup,
  Icon,
  Loading,
  Text,
} from '@cubeyou-team/hx-react-components';
import theme from '@cubeyou-team/hx-theme';
import { useSelector } from 'react-redux';

import { DATA_SOURCE_IDS, FUSION_TYPES } from '@discover-frontend/constants';
import { getProductScope } from '@discover-frontend/utils';
import QueryPreviewContent from './components/QueryPreviewContent';
import {
  hasGwiFusion,
  hasWWGwiMediaFusion,
  hasMriSimmonsFusion,
  hasTgiFusion,
} from '../../utils/AuthHelperMethods';
import { ApiRequestHeader, fetchWrapper } from '../../utils';
import { API } from '../../constants/config';
import { prepareNewAudience } from '../../operations/repository';
import { mapQueryBlocksWithUniqueIdAndFormat } from '../../operations/query';

const getEndpointBaseUrl = (api, mock) =>
  mock ? API[api].MOCK_BASE_URL : API[api].BASE_URL;

const fullUrl = `${getEndpointBaseUrl(
  'ENGINE_AFFINITY',
  false
)}/insights/translate`;

function fetchTranslateQuery(query) {
  const data = {
    ...query,
  };
  data.scope = getProductScope();

  if (data.data_source === DATA_SOURCE_IDS.TWITTER) {
    if (hasMriSimmonsFusion()) data.partner_source = FUSION_TYPES.MRI_SIMMONS;
    if (hasGwiFusion()) data.partner_source = FUSION_TYPES.GWI;
    if (hasWWGwiMediaFusion()) data.partner_source = FUSION_TYPES.WW_GWI_MED;
    if (hasTgiFusion()) data.partner_source = FUSION_TYPES.TGI;
  }
  const endpointUrl = fullUrl;
  const authRequestHeader = ApiRequestHeader();

  return fetchWrapper(endpointUrl, authRequestHeader, 'POST', data);
}

const QueryPreview = ({
  queryPreview,
  defaultLayout = 'vertical',
  defaultView = 'basic',
}) => {
  const dataSource = useSelector((state) => state.queryBuilder.dataSource);
  const {
    query_type,
    target_query,
    queryEntitiesInfos,
    conversationQueries,
    isLoading,
    data_source = dataSource,
  } = queryPreview;
  const [layout, setLayout] = useState(defaultLayout);
  const [view, setView] = useState(defaultView);
  const [isTranslationLoading, setTranslationLoading] = useState(false);
  const [query, setQuery] = useState(target_query);

  useEffect(() => {
    setTranslationLoading(true);
    const body = prepareNewAudience({ ...queryPreview, data_source });

    if (view !== 'basic') {
      fetchTranslateQuery(body).then(({ response, error }) => {
        if (!error) {
          setTranslationLoading(false);
          setQuery(
            mapQueryBlocksWithUniqueIdAndFormat(response.data.target_query)
          );
        }
      });
    } else {
      setTranslationLoading(false);
      setQuery(queryPreview.target_query);
    }
  }, [view, queryPreview, target_query, data_source]);

  const isEmpty =
    !target_query || (target_query && target_query.arguments_list.length === 0);
  if (isEmpty || isLoading) {
    return null;
  }
  return (
    <Box style={{ height: '100%' }}>
      <div style={{ display: 'flex', paddingTop: theme.spacing.small }}>
        {query_type !== 'conversation' && (
          <Box pR="large">
            <ButtonToggleGroup
              selected={view}
              onChange={(value) => {
                setView(value);
              }}
            >
              <ButtonToggle value="basic">
                <Text size="xbody">Basic view</Text>
              </ButtonToggle>
              <ButtonToggle value="full">
                <Text size="xbody">Full view</Text>
              </ButtonToggle>
            </ButtonToggleGroup>
          </Box>
        )}
        <Box>
          <ButtonToggleGroup
            onChange={setLayout}
            selected={layout}
            size="small"
          >
            <ButtonToggle value="vertical">
              <Icon size="small" icon="vertical_text" />
            </ButtonToggle>
            <ButtonToggle value="horizontal">
              <Icon size="small" icon="horizontal_text" />
            </ButtonToggle>
          </ButtonToggleGroup>
        </Box>
      </div>
      <Box pT="medium" className="pb-24">
        <Loading isLoading={isTranslationLoading}>
          <QueryPreviewContent
            layout={layout}
            type={query_type}
            query={query}
            queryEntitiesInfos={queryEntitiesInfos}
            conversationQueries={conversationQueries}
          />
        </Loading>
      </Box>
    </Box>
  );
};

QueryPreview.defaultProps = {
  queryPreview: {},
};

export default QueryPreview;
